import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../core/useAuth';

export const FakeJwtLogin = () => {
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('x');
  const [loginError, setLoginError] = useState(null);

  const returnTo = location.state?.returnTo || '/dashboard/hosting';

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoginError(null);

    try {
      await login({ username, password });
      navigate(returnTo, { replace: true });
    } catch (error) {
      setLoginError(error);
    }
  };

  return (
    <div>
      <h1>Fake-JWT Login</h1>
      <p>
        Local backend with the fake-jwt profile: the username must name an
        rbac.subject (e.g. hsh-demo_admin), the password is not checked.
      </p>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username">User</label>
          <input
            id="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            placeholder="hsh-demo_admin"
            autoComplete="username"
          />
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
          />
        </div>

        {loginError && <p role="alert">{loginError.message}</p>}

        <button type="submit">Sign In</button>
      </form>
    </div>
  );
};
